import type { MenuTranslations } from "Infrastructure/Translation/Types/menu";
import { MenuItemTypes } from "Shared/Components/Layout/Full/Sidebar/Types/MenuItem";

export const menuTranslations: MenuTranslations = {
	title: "Menu",
	navigation: {
		[MenuItemTypes.Settings]: "Settings",
		[MenuItemTypes.Users]: "Users",
		[MenuItemTypes.UsersCreate]: "Add user",
		[MenuItemTypes.UsersProfile]: "Profiles",
		[MenuItemTypes.UsersRoles]: "Roles",
		[MenuItemTypes.Markets]: "Markets",
		[MenuItemTypes.MyProfile]: "My profile",
		[MenuItemTypes.Orders]: "Orders",
		[MenuItemTypes.OrdersList]: "Orders list",
		[MenuItemTypes.Invoices]: "Payment requests",
		[MenuItemTypes.VerticalSetup]: "Vertical setup",
		[MenuItemTypes.Partners]: "Partners",
		[MenuItemTypes.PartnersList]: "Partners list",
		[MenuItemTypes.PartnersStatistics]: "Statistics",
		[MenuItemTypes.Claims]: "Claims",
		[MenuItemTypes.Company]: "Company",
		[MenuItemTypes.Payments]: "Payments",
		[MenuItemTypes.Calendar]: "Calendar",
		[MenuItemTypes.PartnershipRecords]: "Morning Check",
	},
};
